$(document).ready(function(){
    const initProductCardSliders = function($slider, $thumb){
        const slider = new Swiper($slider[0], {
            slidesPerView: 1,
            lazy: {
                loadPrevNext: true,
            },
            breakpoints : {
                0 : {
                    pagination: {
                        el: $slider.find('.swiper-pagination')[0],
                        clickable: true,
                    },
                },
                992 : {
                    pagination: false,
                }
            }
        });

        const thumb = new Swiper($thumb[0], {
            slidesPerView: 'auto',
            pagination: false,
            spaceBetween: 10,
            direction: "vertical",
            navigation: {
                nextEl: $thumb.parent().find('.product-card-main__arrow--next')[0],
                prevEl: $thumb.parent().find('.product-card-main__arrow--prev')[0],
            },
        });

        slider.on('slideChange', function () {
            thumb.slideTo(slider.activeIndex);
            thumb.slides.forEach(slide => slide.classList.remove('active'));
            thumb.slides[slider.activeIndex].classList.add('active');
        });

        $thumb.off('click', '.product-card-main__thumb-slide')
            .on('click', '.product-card-main__thumb-slide', function(){
                const index = $(this).attr('data-index');

                slider.slideTo(index);
            });
    };

    const translateProductGallery = function(){
        const $container = $('.product-card-main__container'),
            $gallery = $('.product-card-main__gallery');

        if ($(window).outerWidth() > 991){
            const scrollTop = $(window).scrollTop(),
                scrollTopMin = 93,
                scrollTopMax = $container.outerHeight() - $gallery.outerHeight() - 50;

            if (scrollTop > scrollTopMin){
                let scrollTopPos = scrollTop - scrollTopMin;

                if (scrollTopPos < scrollTopMin){
                    scrollTopPos = 0;
                } else if (scrollTopPos > scrollTopMax) {
                    scrollTopPos = scrollTopMax;
                }

                $gallery.css('transform', 'translateY('+scrollTopPos+'px)');
            }
        } else {
            $gallery.removeAttr('style');
        }
    };

    if ($('.product-card-main__gallery').length) {
        translateProductGallery();

        $(window).scroll(function () {
            translateProductGallery();
        });

        let translateIntervals = null;

        $(document).on('click', '.js-accordion-toggle', function(){
            if ($(window).outerWidth() > 991){
                translateProductGallery();

                if (translateIntervals != null){
                    clearInterval(translateIntervals);
                    translateIntervals = null;
                }

                let index = 5;

                translateIntervals = setInterval(function() {
                    index += 10;

                    if (index >= 500){
                        clearInterval(translateIntervals);
                        translateIntervals = null;
                    }

                    translateProductGallery();
                }, 10);
            }
        });
    }

    $(document).on('click', '.js-quick-view-v2', function () {
        var productId = $(this).data('product_id')
        $.ajax({
            url: '/catalog/quick-view2/',
            type: 'post',
            dataType: 'json',
            data: {
                productId: productId
            },
            success: function (data) {
                const html = $(data.html);

                if (!$('#modal-quick-view').length) {
                    $('body').append(html);
                } else {
                    $('#modal-quick-view .js_modal__content').html(html.find('.js_modal__content').html())
                }

                openModal($('#modal-quick-view'), 'modal-bg');
                initProductCardSliders(
                    $('.js-product-main-slider-modal')
                );
            }
        });
    });

    $('.js-product-main-slider').each(function(){
        initProductCardSliders(
            $(this),
            $('.js-product-thumbs-slider')
        );
    });

    $('.ns-product-reviews').each(function(){
        new Swiper($(this)[0], {
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                nextEl: $(this).find('.swiper-button-next')[0],
                prevEl: $(this).find('.swiper-button-prev')[0],
            },
        });
    });

    $('.js-ns-catalog-scroll-to-card').click(function(){
        $('html, body').animate({
            scrollTop : $('.product-card-main__name').offset().top - 100
        }, 500);
    });

    $(document).on('click', function(e){
        const $target = $(e.target);

        if ($target.parents('.product-card-main__ns-size').length || $target.hasClass('product-card-main__ns-size')) {
            return true;
        }

        $('.product-card-main__ns-size').removeClass('_show');
    }).on('click', '.product-card-main__ns-size-current', function(){
        $('.product-card-main__ns-size').toggleClass('_show');
    }).on('click', '.product-card-main__ns-size-item', function(){
        const $wrap = $('.product-card-main__ns-size'),
            $items = $('.product-card-main__ns-size-items');

        $wrap.removeClass('_show');

        const selfHtml = $(this).html(),
            $current = $('.product-card-main__ns-size-current');

        $current.html(selfHtml);

        $items.find('._hide').removeClass('_hide');
        $current.find('input').prop('checked', true);

        $(this).addClass('_hide');

        if ($('.product-card-main__price-old').length && $(this).attr('data-price-old') != null){
            $('.product-card-main__price-old').text($(this).attr('data-price-old'));
        }

        $('.js-product-card-main__product-number').text($(this).find('input').attr('data-code'));
        $('.product-card-main__price').html($(this).attr('data-price'));
        $('.product-card-main__credit-box-price').html($(this).attr('data-price2'));
    });

    $('.product-video-slider').each(function(){
        new Swiper($(this)[0], {
            slidesPerView: 1,
            navigation: {
                nextEl: $(this).find('.swiper-button-next')[0],
                prevEl: $(this).find('.swiper-button-prev')[0],
            },
        });
    });

    $('.js-enhance-skills-link[data-link]').click(function(e){
         e.preventDefault();

         window.location.href = $(this).attr('data-link');
    });
});
